import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=3ee4b06b&scoped=true&"
import script from "./ModalWindow.vue?vue&type=script&lang=js&"
export * from "./ModalWindow.vue?vue&type=script&lang=js&"
import style0 from "./ModalWindow.vue?vue&type=style&index=0&id=3ee4b06b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee4b06b",
  null
  
)

export default component.exports